import { getLocalIdentity } from '@meitu/xdesign-identity';
import { REACT_APP_APP_KEY, REACT_APP_APP_KEY_TEAM } from '@/react-process-env';

export function getAppKey(oid?: number) {
    const APP_KEY = REACT_APP_APP_KEY;
    const APP_KEY_TEAM = REACT_APP_APP_KEY_TEAM;

    return (oid ?? getLocalIdentity()?.oid) ? APP_KEY_TEAM || APP_KEY : APP_KEY;
}
